import { InjectableClass } from '@fino/lib-injection';
import { CardBuilder } from './card.builder';

export class CardBuildingService extends InjectableClass {
  constructor(CardStates, IconMappings) {
    'ngInject';
    super({
      CardStates,
      IconMappings,
    });
  }

  buildFor(element) {
    this.builder = new CardBuilder(element);
    return this;
  }

  buildWithBindingFor(element) {
    this.builder = new CardBuilder(element, true);
    return this;
  }

  onChange(callback) {
    this.builder.onChange(callback);
    return this;
  }

  isRemovable(onRemove, removed) {
    this.builder.removable(onRemove, removed);
    return this;
  }

  isReadonly(readonly) {
    this.builder.readonly(readonly);
    return this;
  }

  hasMultipleContracts() {
    this.builder.multipleContracts();
    return this;
  }

  withHeader(setter) {
    this.builder.field('header', setter);
    return this;
  }

  withSubHeader(setter) {
    this.builder.field('subHeader', setter);
    return this;
  }

  withIconClass(setter) {
    const mapping = this.IconMappings[this.CardStates.Category];
    this.builder.field('iconClass', setter, mapping);
    return this;
  }

  withContractingPartners(onSelect, selected) {
    this.builder.contractingPartners(onSelect, selected);
    return this;
  }

  withInformOnlineStatus(bindingPath, iconMapping) {
    return this.withStatus(
      this.CardStates.InformOnline,
      bindingPath,
      iconMapping,
    );
  }

  withCategoryStatus(bindingPath, iconMapping) {
    return this.withStatus(this.CardStates.Category, bindingPath, iconMapping);
  }

  withStatus(statusName, bindingPath, iconMapping) {
    iconMapping = iconMapping || this.IconMappings[statusName];
    this.builder.status(statusName, bindingPath, iconMapping);
    return this;
  }

  withAction(actionName, callbackOrBinding, valueOrMapping, options) {
    const args = [actionName, callbackOrBinding, valueOrMapping, options];
    if (angular.isFunction(callbackOrBinding)) {
      this.builder.actionWithCallback(...args);
      return this;
    }
    this.builder.actionWithBinding(...args);
    return this;
  }

  return() {
    return this.builder.getCard();
  }
}
